import { Stack, styled } from "@mui/material";
import { InternalButtonLink } from "@repo/ui";
import type { ComponentProps, FC } from "react";
export { BannerWrapper, ButtonContainer } from "./BannerCommon.styled";
import {
    HeadingContainer as BaseHeadingContainer,
    HighlightedText as BaseHighlightedText,
    InlineText as BaseInlineText,
} from "./BannerCommon.styled";

const FONT_SIZE = "2.7rem";

export const ContentContainer = styled(Stack)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    textAlign: "left",
    [theme.breakpoints.up("md")]: {
        marginLeft: theme.spacing(4),
    },
}));

export const HeadingContainer = styled(BaseHeadingContainer)(({ theme }) =>
    theme.unstable_sx({
        [theme.breakpoints.up("md")]: {
            fontSize: FONT_SIZE,
        },
    }),
);

export const HighlightedText = styled(BaseHighlightedText)(({ theme }) =>
    theme.unstable_sx({
        [theme.breakpoints.up("md")]: {
            fontSize: FONT_SIZE,
        },
    }),
);

export const InlineText = styled(BaseInlineText)(({ theme }) =>
    theme.unstable_sx({
        [theme.breakpoints.up("md")]: {
            fontSize: FONT_SIZE,
        },
    }),
);

export const StyledButton: FC<Omit<ComponentProps<typeof InternalButtonLink>, "variant" | "size">> = (props) => (
    <InternalButtonLink variant="contained" size="medium" {...props} />
);
